export default "__VITE_ASSET__BFImcwLY__"